import React, { useEffect, useState } from 'react';
import CorpoPagina from '../../../Componentes/CorpoPagina';
import Espaçador from '../../../Componentes/Espaçador';
import TopicoTexto from '../../../Componentes/TopicoTexto';
import CardDashboardAmbiente from '../../../Componentes/CardDashboardAmbiente';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  ReferenceArea,
  ResponsiveContainer,
  Label,
  Tooltip,
} from 'recharts';
import SelectInput from '../../../Componentes/SelectInput';
import CardDashboardVazio from '../../../Componentes/CardDashboardVazio';
import DateInput from '../../../Componentes/DateInput';
import ModalConfirmacao from '../../../Componentes/ModalConfirmacao';
import { useRef } from 'react';
import { useMediaQuery } from 'react-responsive';
import { apiService } from '../../../Services/ApiService';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import DashboardTabs from './DashboardTabs';

export default function DashBoardDetalhes() {
  const navigate = useNavigate();
  const { id } = useParams();
  const abertura = '24%';
  const topo = 16;
  const [dashboard, setDashboard] = useState([]);
  const componentRef = useRef();
  const isMobile = useMediaQuery({ query: `(max-width: 920px)` });
  const { get } = apiService();
  const [modalError, setModalError] = useState({
    visible: false,
    message: '',
  });
  const [alerts, setAlerts] = useState([]);
  const alertNature = {
    AIR_CURTAIN_DISABLED: 'Cortina de ar fora de funcionamento',
    DEHUMIDIFIER_DISABLED: 'Desumidificador fora de funcionamento',
    ENERGY_DISABLED: 'Falta de energia elétrica',
    ENVIRONMENT_OPEN: 'Forro de ambiente aberto',
    COOLER_DISABLED: 'Máquina de refrigeração fora de funcionamento',
    REFRIGERATOR_DOOR_OPEN: 'Porta da geladeira aberta acima do tempo permitido',
    ENVIRONMENT_DOOR_OPEN: 'Porta do ambiente aberta',
    OPEN_DOOR: 'Porta aberta',
    NA: 'N/A',
  };
  const [isPrinting, setIsPrinting] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [atualizacao, setAtualizacao] = useState(0);
  const [selectedDaysLabel, setSelectedDaysLabel] = useState('Selecione');
  const [hasSelectedTime, setHasSelectedTime] = useState(false);
  const [hasSelectedDate, setHasSelectedDate] = useState(true);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [timeoutId, setTimeoutId] = useState(null);
  const [initialSelectionDone, setInitialSelectionDone] = useState(false);
  const rangerDays = [
    { value: 180000, label: 'A cada 3 minutos' },
    { value: 600000, label: 'A cada 10 minutos' },
    { value: 900000, label: 'A cada 15 minutos' },
    { value: 1800000, label: 'A cada 30 minutos' },
  ];
  const [selectedPeriodLabel, setSelectedPeriodLabel] = useState(null);
  const [selectedPeriodValue, setSelectedPeriodValue] = useState(null);
  const [hasSelectedPeriod, setHasSelectedPeriod] = useState(false);
  const [initialPeriodDone, setInitialPeriodDone] = useState(false);
  const periods = [
    { value: 'daily', label: 'Diário' },
    { value: 'last_7_days', label: 'Últimos 7 dias' },
    { value: 'last_15_days', label: 'Últimos 15 dias' },
    { value: 'last_30_days', label: 'Últimos 30 dias' },
  ];
  const startAutoUpdate = (interval) => {
    const ids = setInterval(() => {
      getDashboard();
    }, interval);
    setTimeoutId(ids);
  };

  useEffect(() => {
    if (id && selectedDate && selectedPeriodValue) {
      getDashboard();
    }
  }, [id, selectedDate, selectedPeriodValue]);

  //? setTime
  const handleSelecionar = (item) => {
    setSelectedDaysLabel(item.label);
    setAtualizacao(item.value);
    setHasSelectedTime(true);
    if (timeoutId) {
      clearInterval(timeoutId);
    }
    startAutoUpdate(item.value);
  };

  useEffect(() => {
    return () => {
      if (timeoutId) {
        clearInterval(timeoutId);
      }
    };
  }, [timeoutId]);

  //? period
  const handleSelecionarPeriod = (selected) => {
    setSelectedPeriodLabel(selected.label);
    setSelectedPeriodValue(selected.value);
    setHasSelectedPeriod(true);
    setAtualizacao(selected.value);
  };

  const getDashboard = async () => {
    try {
      if (id && selectedDate && selectedPeriodValue) {
        setIsLoading(true);
        const formattedDate = selectedDate.toISOString();
        const period = selectedPeriodValue;
        const endpoint = `dashboard/readings/refrigerator?environmentId=${id}&date=${formattedDate}&timePeriod=${period}`;
        const response = await get(endpoint);
        if (response && response.temperatureData) {
          const {
            temperatureData,
            averageTemperature,
            minTemperature,
            maxTemperature,
            // maxTemperatureOffset,
            // minTemperatureOffset,
            latestTemperature,
            latestDate,
            energy,
            endOfCourse,
            name,
          } = response;

          if (temperatureData.length > 0) {
            setDashboard([
              {
                temperatureData,
                averageTemperature,
                minTemperature,
                maxTemperature,
                // maxTemperatureOffset,
                // minTemperatureOffset,
                latestTemperature,
                latestDate,
                energy,
                endOfCourse,
                name,
              },
            ]);
          } else {
            setDashboard([]);
          }
        } else {
          setModalError({ visible: true, message: 'Resposta inválida da API' });
        }
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setModalError({ visible: true, message: 'Erro ao buscar dados do ambiente' });
    } finally {
      setIsLoading(false);
    }
  };

  //? select first RangerDys
  useEffect(() => {
    if (rangerDays.length > 0 && !initialSelectionDone) {
      const firstRange = rangerDays[0];
      handleSelecionar(firstRange);
      setInitialSelectionDone(true);
    }
  }, [rangerDays, initialSelectionDone]);

  //? select first Period
  useEffect(() => {
    if (periods.length > 0 && !initialPeriodDone) {
      const firstPeriod = periods[0];
      handleSelecionarPeriod(firstPeriod);
      setInitialPeriodDone(true);
    }
  }, [periods, initialPeriodDone]);

  //? select atual date
  useEffect(() => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    setSelectedDate(today);
  }, []);

  const handleNavigate = () => {
    navigate(`/Dashboard`);
  };

  function defineStatus(tempMinimo, tempMaximo, atual) {
    if (atual < tempMinimo || atual > tempMaximo) {
      return 'NG';
    } else if (atual > tempMinimo + 1 && atual < tempMaximo - 1) {
      return 'OK';
    } else {
      return 'WARN';
    }
  }

  function GetColor(status) {
    if (status === 'OK') {
      return 'green';
    } else {
      return '#C46F61';
    }
  }
  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };

  const getAlerts = async () => {
    setIsLoading(true);
    try {
      const data = await get('alerts/refrigerator/dashboard');
      if (data) {
        const alertsList = data || [];
        setAlerts(alertsList);
      }
    } catch (error) {
      setModalError({ visible: true, message: 'Erro ao buscar alertas' });
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    getAlerts();
  }, []);

  return (
    <CorpoPagina loading={isLoading}>
      {modalError.visible && (
        <ModalConfirmacao
          aviso={modalError.message}
          erro={true}
          clicado={() => setModalError({ visible: false, message: '' })}
        />
      )}
      <div
        className="ContainerGeral"
        ref={componentRef}
        style={isPrinting ? { marginTop: '5%' } : null}
      >
        {!isPrinting ? <DashboardTabs /> : null}
        <TopicoTexto
          titulo={`Dashboard: ${dashboard.map((item) => item.name)}`}
          largura={isMobile ? '100%' : '80%'}
        />
        {!isPrinting ? (
          <h3 style={{ color: '#005288' }}>Procedimento de Referência:13-FS20-1000-00002-AM</h3>
        ) : null}
        <div className="CamposDashboard" style={{ width: isMobile ? '100%' : '98%' }}>
          <div className="CamposDashboard Esquerda" style={{ width: isMobile ? '100%' : '75%' }}>
            {!isPrinting ? (
              <SelectInput
                top={0}
                bottom={12}
                padrao={{ value: '', label: selectedDaysLabel }}
                titulo="Alternar Tempo"
                largura={isMobile ? '90%' : '30%'}
                itens={rangerDays}
                clicado={handleSelecionar}
                erro={!hasSelectedTime}
                erroTexto="Selecione o tempo"
              />
            ) : null}
            <Espaçador espaço={16} />
            <DateInput
              marginLeft={0}
              top={0}
              titulo="Data Selecionada"
              largura={isMobile ? '90%' : '30%'}
              clicado={(d) => {
                setSelectedDate(d ? new Date(d) : null);
                setHasSelectedDate(true);
              }}
              padrao={selectedDate}
              erro={!hasSelectedDate}
              erroTexto="Selecione a data"
            />
            <Espaçador espaço={16} />
            <SelectInput
              top={0}
              titulo="Selecione o Período"
              bottom={12}
              padrao={{ value: '', label: selectedPeriodLabel }}
              largura={isMobile ? '90%' : '30%'}
              itens={periods}
              clicado={handleSelecionarPeriod}
            />
          </div>
          <div className="CamposDashboard Direita" style={{ width: isMobile ? '18%' : '0%' }}>
            <img
              className="Direita"
              src={require('../../../Icones/icone_impressão.svg').default}
              alt="Impressão"
              onClick={() => {
                setIsPrinting(true);
                setTimeout(() => {
                  window.print();
                  setIsPrinting(false);
                }, 500);
              }}
            />
          </div>
        </div>
        <div className="CamposCard">
          <div
            style={
              !isPrinting
                ? {
                    display: 'flex',
                    flexDirection: 'row',
                    width: '80vw',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                  }
                : {
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100vw',
                    marginTop: '40px',
                    justifyContent: 'space-between',
                  }
            }
          >
            <CardDashboardAmbiente
              tipo="TEMPERATURA"
              height={250}
              maxW={600}
              minW={200}
              top={topo}
              width={abertura}
              valor={dashboard.map((items) => parseFloat(items.latestTemperature).toFixed(2))}
              ok={defineStatus(
                dashboard.map((items) => items.minTemperature),
                dashboard.map((items) => items.maxTemperature),
                dashboard.map((items) => items.latestTemperature)
                  ? dashboard.map((items) => items.latestTemperature)
                  : 0,
              )}
              minimo={dashboard.map((items) => items.minTemperature)}
              maximo={dashboard.map((items) => items.maxTemperature)}
              data={formatDate(dashboard.map((items) => items.latestDate))}
            />

            <CardDashboardAmbiente
              tipo="MÉDIA DE TEMPERATURA"
              height={250}
              minW={200}
              maxW={600}
              top={topo}
              width={abertura}
              valor={dashboard.map((items) => parseFloat(items.averageTemperature).toFixed(2))}
              minimo={dashboard.map((items) => items.minTemperature)}
              maximo={dashboard.map((items) => items.maxTemperature)}
            />

            <CardDashboardVazio
              height={250}
              maxW={600}
              minW={200}
              classe={'L'}
              top={topo}
              width={isMobile ? '45%' : abertura}
            >
              <div className={`CardView `}>
                <div id="CardDetalhes">
                  <h4 id="FonteCard">PORTA ABERTA</h4>
                </div>

                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    margin: 0,
                    padding: 0,
                    justifyContent: 'center',
                    flexDirection: 'column',
                    height: 120,
                    width: 120,
                    borderRadius: 60,
                    border: `3px solid ${GetColor(
                      dashboard.some((items) => items.endOfCourse === false) ? 'OK' : 'NG',
                    )}`,
                  }}
                >
                  {dashboard.some((items) => items.endOfCourse === false) ? (
                    <img src={require('../../../Icones/portaOK.svg').default} alt="Porta Fechada" />
                  ) : (
                    <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                      <img src={require('../../../Icones/PortaFechada.png')} alt="Porta Aberta" />
                    </div>
                  )}
                </div>

                <div style={{ display: 'flex', width: '100%', height: 30 }}>
                  <h6 id="FonteID">
                    {dashboard.length === 0
                      ? 'Sem Leitura'
                      : dashboard.some((items) => items.endOfCourse === false)
                      ? 'Porta Fechada'
                      : 'Porta Aberta'}
                  </h6>
                </div>
              </div>
            </CardDashboardVazio>

            <CardDashboardVazio
              height={250}
              maxW={600}
              classe={'L'}
              minW={200}
              top={topo}
              width={isMobile ? '45%' : abertura}
            >
              <div className={`CardView `}>
                <div id="CardDetalhes">
                  <div id="TituloCardView">
                    <h4 id="FonteCard">ENERGIA</h4>
                  </div>
                </div>

                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    margin: 0,
                    padding: 0,
                    justifyContent: 'center',
                    flexDirection: 'column',
                    height: 120,
                    width: 120,
                    borderRadius: 60,
                    border: `3px solid ${GetColor(
                      dashboard.some((items) => items.energy === true) ? 'OK' : 'NG',
                    )}`,
                  }}
                >
                  {dashboard.some((items) => items.energy === true) ? (
                    <img src={require('../../../Icones/raio_icone.svg').default} />
                  ) : (
                    <img src={require('../../../Icones/raio_off.png')} />
                  )}
                </div>
                <div style={{ display: 'flex', width: '100%', height: 30 }}>
                  <h6 id="FonteID">
                    {dashboard.length === 0
                      ? 'Sem Leitura'
                      : dashboard.some((items) => items.energy === true)
                      ? 'Com Energia'
                      : 'Sem Energia'}
                  </h6>
                </div>
              </div>
            </CardDashboardVazio>
          </div>
        </div>
        <div className="DashboardContainer">
          <div className="DashboardFlexContainer">
            <div className="DashTemp">
              <CardDashboardVazio height={600} top={32} width={'100%'} maxW={3000}>
                <div className="TemperatureGraphHeader">
                  <h4 id="FonteCard" style={{ paddingLeft: 16 }}>
                    GRÁFICO DE TEMPERATURA
                  </h4>
                </div>
                <div className={!isPrinting ? 'GraphContainer' : 'GraphContainerPrint'}>
                  <div className="statView">
                    <div className="ConfiguredValuesContainer">
                      <p className="ConfiguredValuesText" style={{ fontWeight: 'bold' }}>
                        Padrão
                      </p>
                      <div style={{ display: 'flex', flexDirection: 'row', gap: '30px' }}>
                        <p>Min: {dashboard.map((items) => items.minTemperature)} °C</p>
                        <p>Máx: {dashboard.map((items) => items.maxTemperature)} °C</p>
                      </div>
                    </div>
                    <div className="DailyValueContainer">
                      <p className="DailyValueTitle" style={{ fontWeight: 'bold' }}>
                        Resultado diário
                      </p>
                      <p style={{ marginLeft: '50px' }}>
                        {dashboard.map((items) => items.averageTemperature)} °C
                      </p>
                    </div>
                    {/* <div style={{ marginLeft: 'auto' }}>
                    <SelectInput
                      top={-35}
                      bottom={0}
                      padrao={{ value: '', label: selectedPeriodLabel }}
                      // largura={'20%'}
                      itens={periods}
                      clicado={handleSelecionarPeriod}
                    />
                  </div> */}
                  </div>
                  <ResponsiveContainer width={'100%'} height="65%">
                    <LineChart width={500} height={100} data={dashboard[0]?.temperatureData}>
                      <CartesianGrid stroke="#ccc" strokeWidth={2} strokeDasharray="3 3" fill="" />
                      <XAxis dataKey="time" angle={0} />
                      <YAxis
                        yAxisId="left"
                        domain={[
                          dashboard.length > 0
                            ? Math.max(...dashboard.map((item) => item.minTemperature))
                            : null,
                          dashboard.length > 0
                            ? Math.max(...dashboard.map((item) => item.maxTemperature))
                            : null,
                        ]}
                        label={
                          <Label
                            dx={-30}
                            angle={270}
                            style={{ fontFamily: 'montserrat', fontSize: 15 }}
                          >
                            Temperatura (°C)
                          </Label>
                        }
                        position="top"
                      />
                      <YAxis
                        yAxisId="right"
                        orientation="right"
                        label={
                          <Label
                            dx={10}
                            angle={270}
                            style={{ fontFamily: 'montserrat', fontSize: '15' }}
                          >
                            Temperatura (°C)
                          </Label>
                        }
                      />
                      <Line
                        yAxisId="left"
                        type="monotone"
                        dataKey="temperature"
                        stroke="#205284"
                        activeDot={{ r: 8 }}
                        dot={true}
                        isAnimationActive={false}
                      />
                      <Tooltip
                        content={({ payload, label }) => {
                          if (payload && payload.length > 0) {
                            const {
                              payload: { temperature },
                            } = payload[0];
                            return (
                              <div style={{ backgroundColor: 'white', padding: '5px' }}>
                                <p>Hora: {label}</p>
                                <p>Temperatura: {temperature} °C</p>
                              </div>
                            );
                          }
                          return null;
                        }}
                      />
                      <ReferenceArea
                        yAxisId="left"
                        y1={dashboard[0]?.minTemperature}
                        y2={dashboard[0]?.maxTemperature}
                        fill="#6FB433"
                      />
                      {/* //? yellow area superior
                    <ReferenceArea
                      yAxisId="left"
                      y1={dashboard[0]?.maxTemperatureOffset}
                      y2={dashboard[0]?.maxTemperature}
                      fill="#E67E03"
                    />
                    //? yellow area inferior
                    <ReferenceArea
                      yAxisId="left"
                      y1={dashboard[0]?.minTemperature}
                      y2={dashboard[0]?.minTemperatureOffset}
                      fill="#E67E03"
                    /> */}
                      <ReferenceArea
                        yAxisId="left"
                        y1={
                          dashboard[0]?.temperatureData && dashboard[0]?.temperatureData.length > 0
                            ? Math.min(
                                ...dashboard[0].temperatureData.map((item) => item.temperature),
                              ) > 0
                              ? 0
                              : Math.min(
                                  ...dashboard[0].temperatureData.map((item) => item.temperature),
                                )
                            : undefined
                        }
                        y2={dashboard[0]?.minTemperature}
                        fill="#E8061D"
                      />
                      {dashboard.length > 0 && (
                        <ReferenceArea
                          yAxisId="left"
                          y1={dashboard[0]?.maxTemperature}
                          // y2={Math.max(
                          //   ...dashboard[0].temperatureData.map((item) => item.temperature),
                          // )}
                          fill="#E8061D"
                        />
                      )}
                    </LineChart>
                  </ResponsiveContainer>
                </div>
                <div className="legendContainer">
                  <div className="legendItem">
                    <div
                      className="legendCircleReading"
                      style={{ backgroundColor: 'white', borderColor: '#2E5280' }}
                    />
                    <p className="legend">LEITURA</p>
                  </div>
                  <div className="legendItemTime">
                    <div className="legendCircle" />
                    <p className="legend">-TEMPO-</p>
                  </div>
                  <div className="legendItemColor">
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <div className="legendCircle" style={{ backgroundColor: '#6FB433' }} />
                      <p className="legend">DENTRO DO PADRÃO</p>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <div className="legendCircle" style={{ backgroundColor: '#E67E03' }} />
                      <p className="legend">ÁREA DE ATENÇÃO</p>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <div className="legendCircle" style={{ backgroundColor: '#E8061D' }} />
                      <p className="legend">FORA DO PADRÃO</p>
                    </div>
                  </div>
                </div>
              </CardDashboardVazio>
            </div>
          </div>
          {alerts.map((items) => items).length > 0 ? (
            <div
              className="DashboardFlexContainer "
              style={isPrinting ? { marginTop: '30%' } : isMobile ? { marginTop: '40%' } : null}
            >
              <CardDashboardVazio height={'100%'} top={32} width={'100%'} maxW={3000}>
                <div className="TemperatureGraphHeader">
                  <h4 id="FonteCard" style={{ paddingLeft: 10 }}>
                    ÚLTIMOS ALERTAS
                  </h4>
                </div>
                {alerts.map((alert, index) => (
                  <div key={index} className="AlertListItem">
                    <p className="AlertNature">
                      <div className="AlertIcon"></div>
                      {alertNature[alert.nature] || 'Não definido'}
                    </p>
                    <p className="AlertTimestamp">{new Date(alert.updatedAt).toLocaleString()}</p>
                  </div>
                ))}
              </CardDashboardVazio>
            </div>
          ) : null}
          <div className="BotaoView" style={{ marginTop: 32, marginBottom: 32 }}>
            <button id="BotaoVolta" onClick={handleNavigate}>
              Voltar
            </button>
          </div>
        </div>
      </div>
    </CorpoPagina>
  );
}
